export type LoaderSize = 'tiny' | 'small' | 'medium' | 'large';
export type LoaderColor = 'blue' | 'white';
export type LoaderStatus =
  | 'loading'
  | 'loadingWithErrors'
  | 'success'
  | 'error';

export type LoaderProps = {
  /** Applies a data-hook HTML attribute to be used in the tests */
  dataHook?: string;
  /** Controls the size of the loader */
  size?: LoaderSize;
  /** Controls the skin of the loader */
  color?: LoaderColor;
  /** Defines a text message to show below the loader */
  text?: React.ReactNode;
  /** Specifies the status of a loader */
  status?: LoaderStatus;
  /** Defines the message that explains the current status of the loader. Message will be displayed on loader hover. If not given or empty there will be no tooltip. */
  statusMessage?: string;
};
